import React, { useState, useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  ButtonGroup,
} from "reactstrap";
import moment from "moment";
import * as Icons from "react-feather";
import { urlAPI, getUser, getToken } from "utility/Common";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Axios from "axios";
import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import ReactExport from "react-export-excel";

const headerStyle = {
  fontSize: "14px",
  color: "black",
  margin: "1px 1px 1px 1px",
};
const bodyStyle = {
  fontSize: "14px",
  color: "black",
  margin: "1px 1px 1px 1px",
};
const containerStyle = {
  padding: "5px 1px 5px 1px",
};
// const borderStyle = {
//   border: "2px solid black",
// };
// const borderTopNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "none solid solid solid",
// };
// const borderBottomNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "solid solid none solid",
// };
// const borderTopBottomNoneStyle = {
//   border: "2px solid black",
//   borderStyle: "none solid none solid",
// };

class ComponentToPrint extends React.Component {
  constructor(props) {
    super(props);
  }

  groupByBarang(data) {
    if (!data) return [];
    const map = {};
    data.forEach((row) => {
      const key = row?.kodebarang?.trim();
      if (!map[key]) map[key] = [];
      map[key].push(row);
    });
    return Object.values(map);
  }

  render() {
    const data = this.props.dataPrint;
    const groups = this.groupByBarang(data);

    return (
      <div style={containerStyle}>
        <p style={{ ...headerStyle, textAlign: "center" }}>
          <strong>LAPORAN KARTU STOK BARANG SINF</strong>
        </p>
        <br />

        {groups.map((groupData, groupIndex) => (
          <div key={groupIndex} className={groupIndex > 0 ? "page-break" : ""}>
            <Table borderless={true} size="sm">
              <tbody>
                <tr>
                  <td style={{ width: "15%", verticalAlign: "top" }}>
                    <p style={bodyStyle}>TGL PROSES</p>
                    <p style={bodyStyle}>KODE BARANG</p>
                    <p style={bodyStyle}>NAMA BARANG</p>
                    <p style={bodyStyle}>SATUAN</p>
                    <p style={bodyStyle}>UNIT</p>
                  </td>
                  <td style={{ width: "85%", verticalAlign: "top" }}>
                    <p style={bodyStyle}>: {moment()?.format("DD/MM/YYYY")}</p>
                    <p style={bodyStyle}>: {groupData[0]?.kodebarang}</p>
                    <p style={bodyStyle}>: {groupData[0]?.namabarang}</p>
                    <p style={bodyStyle}>: {groupData[0]?.namasatuan}</p>
                    <p style={bodyStyle}>: {groupData[0]?.namaunit}</p>
                  </td>
                </tr>
              </tbody>
            </Table>

            <Table borderless={true} size="sm">
              <tbody>
                <tr>
                  <td style={{ width: "80%", verticalAlign: "top" }}></td>
                  <td style={{ width: "20%", verticalAlign: "top" }}>
                    <p style={bodyStyle}>
                      Stok Akhir{" "}
                      <NumberFormat
                        value={Number(
                          groupData[groupData.length - 1]?.stakhir2 ??
                            groupData[groupData.length - 1]?.stakhir
                        )}
                        displayType={"text"}
                        decimalSeparator={","}
                        thousandSeparator={"."}
                        decimalScale={0}
                        fixedDecimalScale={true}
                      />
                    </p>
                  </td>
                </tr>
              </tbody>
            </Table>
            <br />

            <Table bordered={true} style={{ border: "1px solid black" }}>
              <thead>
                <tr>
                  <th style={{ width: "5%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>NO</strong></p>
                  </th>
                  <th style={{ width: "20%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>TANGGAL ENTRY - JAM</strong></p>
                  </th>
                  <th style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>TGL TRANS</strong></p>
                  </th>
                  <th style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>NO TRANS</strong></p>
                  </th>
                  <th style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>UNIT PEMINTA</strong></p>
                  </th>
                  <th style={{ verticalAlign: "top", border: "1px solid black", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden", maxWidth: "15%" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>KETERANGAN</strong></p>
                  </th>
                  <th style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>SALDO AWAL</strong></p>
                  </th>
                  <th style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>MASUK</strong></p>
                  </th>
                  <th style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>KELUAR</strong></p>
                  </th>
                  <th style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                    <p style={{ ...bodyStyle, textAlign: "center" }}><strong>SALDO</strong></p>
                  </th>
                </tr>
              </thead>
              <tbody>
                {groupData.map((obj, index) => (
                  <tr key={index}>
                    <td style={{ width: "5%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "center" }}>{index + 1}</p>
                    </td>
                    <td style={{ width: "20%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "left" }}>
                        {moment(obj?.tglentry).format("DD/MM/YYYY HH:mm:ss")}
                      </p>
                    </td>
                    <td style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "center" }}>
                        {moment(obj?.tgltrans).format("DD/MM/YYYY")}
                      </p>
                    </td>
                    <td style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "left" }}>{obj?.noref?.trim()}</p>
                    </td>
                    <td style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "left" }}>{obj?.unitpeminta?.trim()}</p>
                    </td>
                    <td style={{ width: "15%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "left" }}>{obj?.keterangan}</p>
                    </td>
                    <td style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "center" }}>
                        <NumberFormat value={Number(obj?.stawal)} displayType={"text"} decimalSeparator={","} thousandSeparator={"."} decimalScale={0} fixedDecimalScale={true} />
                      </p>
                    </td>
                    <td style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "center" }}>
                        <NumberFormat value={Number(obj?.masuk)} displayType={"text"} decimalSeparator={","} thousandSeparator={"."} decimalScale={0} fixedDecimalScale={true} />
                      </p>
                    </td>
                    <td style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "center" }}>
                        <NumberFormat value={Number(obj?.keluar)} displayType={"text"} decimalSeparator={","} thousandSeparator={"."} decimalScale={0} fixedDecimalScale={true} />
                      </p>
                    </td>
                    <td style={{ width: "10%", verticalAlign: "top", border: "1px solid black" }}>
                      <p style={{ ...bodyStyle, textAlign: "center" }}>
                        <NumberFormat value={Number(obj?.stakhir)} displayType={"text"} decimalSeparator={","} thousandSeparator={"."} decimalScale={0} fixedDecimalScale={true} />
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <br />
            <br />
            <br />
            <hr></hr>
          </div>
        ))}
      </div>
    );
  }
}

export default function PrintKartuStok(props) {
  const { open, filter, handleClose } = props;
  const componentRef = useRef();
  const dispatch = useDispatch();
  const [dataPrint, setDataPrint] = useState(null);
  const [loading, setLoading] = useState(false);
  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  useEffect(() => {
    if (open && filter) {
      setLoading(true);
      fetchData();
    }
  }, [open]);

  const fetchData = () => {
    Axios.get(
      urlAPI +
        "/v1/ReportInventory/SINFlappersediaanunit_kartustok?params=" +
        JSON.stringify(filter),
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length > 0) {
          setDataPrint(response?.data?.result?.rows);
        }else{
          setDataPrint([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoading(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoading(false);
        }
      });
  };

  const printStyle = `
 @media all {
  .page-break {
    display: none;
  }
}

@media print {
  html, body {
    height: initial !important;
    overflow: initial !important;
    -webkit-print-color-adjust: exact;
  }
}

@media print {
  .page-break {
    margin-top: 1rem;
    display: block;
    page-break-before: auto;
  }
}

@page {
  size: auto;
  margin: 20mm;
}
  `;

  return (
    <Modal
      isOpen={open}
      toggle={handleClose}
      className="modal-dialog-centered modal-xl"
      backdrop="static"
    >
      <ModalHeader toggle={handleClose}>Data Preview</ModalHeader>
      <ModalBody>
        <ButtonGroup style={{ width: "100%" }}>
          <ExcelFile
            element={
              <Button
                className="btn"
                color="success"
                // style={{ width: "50%" }}
              >
                <Icons.Download size={18} /> Download Excel
              </Button>
            }
            filename={
              "Laporan Persediaan Perunit - Kartu Stok | " +
              moment().format("DD/MM/YYYY")
            }
          >
            <ExcelSheet data={dataPrint} name="Kartu Stok">
              {dataPrint?.length > 0 &&
                Object.keys(dataPrint[0]).map(function (key, index) {
                  return <ExcelColumn label={key} value={key} />;
                })}
            </ExcelSheet>
          </ExcelFile>
          &nbsp;
          <ReactToPrint
            trigger={() => (
              <Button
                color="primary"
                // style={{ width: "50%" }}
                disabled={loading}
                // size="sm"
              >
                <Icons.Printer size={14} /> Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={printStyle}
          />
        </ButtonGroup>

        <hr />
        {loading ? (
          <div className="text-center">
            <h4>Loading...</h4>
          </div>
        ) : (
          <ComponentToPrint
            ref={componentRef}
            dataPrint={dataPrint}
            sbu={filter?.tujuan}
          />
        )}
      </ModalBody>
    </Modal>
  );
}
